import { jwtDecode } from 'jwt-decode'

export const getCookieByName = (name: string) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)

    if (parts.length > 1) {
        return parts.pop()?.split(';')?.shift() || ''
    }

    return ''
}

export const decodeJwtToken = (token: string) => {
    let decodedToken: any
    try {
        decodedToken = jwtDecode(token)
    } catch {
        decodedToken = {}
    }

    const userId = decodedToken?.user_id || ''

    const extra = decodedToken?.extra ? JSON.parse(decodedToken.extra) : {}
    const isBoostUser = extra?.is_chargemap_boost || false

    const expiresAt = decodedToken?.exp
        ? decodedToken.exp * 1000
        : new Date().getTime()
    const expirationDate = new Date(0)
    expirationDate.setTime(expiresAt)

    return [userId, expirationDate, isBoostUser]
}
